<div class="flex flex-column ">
  <div class="flex flex-column">
    <h4 class="m-0 date-line">{{ currentDate | date: 'MMMM d, y':'UTC' }}</h4>

    <div class="flex flex-row align-items-center justify-content-between">
      <span class="welcome-line-1">
        Welcome, {{ (currentUser$ | async)?.firstName }}
        <img class="m-0" ngSrc="/assets/icons/welcome.svg" height="30" width="30" alt="Welcome" />
      </span>

      <div class="flex-row align-items-center quick-actions-container gap-20px">
        
          <ng-container *ngTemplateOutlet="quickActions"></ng-container>
        
      </div>
    </div>

    <span class="welcome-line-2">{{ currentQuote }}</span>
  </div>

  @if (!isAsap) {
  <div class="quick-actions-container-mobile flex-column">
    <ng-container *ngTemplateOutlet="quickActions"></ng-container>
  </div>
  } @else {
  <div class="quick-actions-container-mobile flex-column  mb-4">
    <p-button styleClass="py-2 px-3 w-full block" (click)="submitReport()" label="Submit Report" />
  </div>
  }
  @if ((isAsap) && showUpgradeBanner) {
  <div class="border-round p-3 relative md:p-5" style="background-color: var(--bg-promotional-alert);">
    <p-button class="absolute top-0 right-0 m-2" [style.z-index]="'10'" [text]="true" (click)="dismissUpgradeBanner()"
      ariaLabel="Dismiss upgrade banner">
      <i class="pi pi-times"></i>
    </p-button>

    <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 p-3 md:p-0">
      <div class="flex flex-column gap-2">
        <h1 class="m-0 line-height-2 text-xl">
          Unlock the Full Power of Your ASAP Reports
        </h1>
        <p class="m-0 text-sm">
          Submitting reports is just the first step. With our SMS Essentials plan, you can take
          action, dig into root cause analysis, assign corrective actions, and track safety tasks
          directly in the Safety Assurance module.
        </p>
      </div>

      <p-button class="hidden md:inline-flex" (click)="goToUpgrade()" styleClass="w-max" label="Upgrade Your Plan">
      </p-button>

      <p-button class="md:hidden w-full block" (click)="goToUpgrade()" styleClass="w-full block"
        label="Upgrade Your Plan">
      </p-button>
    </div>
  </div>
  }
  <div class="content-container mt-5">
    <div class="flex flex-column gap-20px w-full">



      <div class="flex justify-content-between">
        @if (isAsap) {
        <h2 class="m-0">Your Active Reports</h2>
        } @else {
        <h2 class="m-0">Your Tasks</h2>
        }
      </div>

      <div class="flex justify-content-between">
        <ng-container>
          <form [formGroup]="filterForm" class="flex flex-row justify-content-between align-items-center w-full gap-2">
            <div class="flex flex-row gap-2 align-items-center">
              <div formGroupName="dateRange">
                <app-home-date-filter 
                  [filterForm]="filterForm.get('dateRange')"
                  (filterApplied)="onFilterApplied($event)">
                </app-home-date-filter>
              </div>

              @if(!isAsap) {  
              <p-dropdown styleClass="dropdown-rounded" [autoDisplayFirst]="false" formControlName="formType"
                [options]="formType" [placeholder]="'All Types'">
              </p-dropdown>
              }
            </div>
          </form>
        </ng-container>
      </div>
      @if(!isPastDueFilter()) {
      <p-messages severity="warn" styleClass="message-warning">
        <ng-template pTemplate>
          <div class="flex align-items-center w-full">
            <img class=m-0 src="/assets/icons/warn.svg" alt="Overdue Tasks">

            <div class="flex flex-wrap justify-content-between align-items-center pl-2 flex-grow-1 gap-2 py-3">
              <p class="font-bold text-900 m-0">You have past due items to address.</p>

              <p-button text="true" label="View Past Due" styleClass="p-0"
                  (click)="loadPastDueTasks()"></p-button>
            </div>

            </div>
          </ng-template>
        </p-messages>
      }

      <div>
        <router-outlet></router-outlet>
      </div>
    </div>

    <div class="flex flex-column gap-3 w-full">
      @if ((isAsap) && showAcsfCard) {

      <app-card [noPadding]="true" [noMargin]="true" [showHeader]="false">
        <div card-body class="p-4">
          <div class="flex align-items-start justify-content-between mb-4">
            <img class="m-0 max-w-8rem" id="img-acsf" alt="ACSF" src="assets/img/acsf-logo.png" />
            <p-button [text]="true" (click)="dismissAcsf()"><i class="pi pi-times"></i></p-button>
          </div>
          <h2 class="m-0">Join ACSF</h2>
          <p class="m-0 tex-sm mt-2 text-justify">Most operators trust ACSF to manage their Aviation Safety Action
            Program. If
            you're not yet a member, joining ACSF gives you end-to-end support, including coordination with the FAA and
            oversight of required steps during the mitigation process.</p>
          <div class="w-full">

            <p-button (click)="openAcsfGuide()" severity="secondary" styleClass="w-full text-center block py-2 my-4">
              <span class="block w-full font-bold">Join ACSF ASAP Program <i
                  class="pi pi-external-link ml-2"></i></span>

            </p-button>

          </div>

          <div class="border-round  px-2 py-1" style="background-color: var(--bg-body);">
             <p class="text-sm m-0 text-justify">If you're already a member of the ACSF ASAP program, add their email
               address as a report recipient in the
               <a class="textlink inline text-sm underline" (click)="startGuide($event)">Quick Start Guide</a>.
             </p>
          </div>
        </div>
      </app-card>

      }
      @if ((isAsap ) && asapFormId) {
      <app-home-asap-performance class="w-full" [isAdmin]="isAdmin$ | async"
        [asapFormId]="asapFormId"></app-home-asap-performance>
      } @else {
      <app-home-crew-performance class="w-full" [isAdmin]="isAdmin$ | async"></app-home-crew-performance>
      }
    </div>

  </div>
</div>

<ng-template #quickActions>

    <p-button styleClass="py-2 w-full lg:w-auto" severity="secondary" (click)="createTask()" label="Create Task" />


    <p-button styleClass="py-2 w-full lg:w-auto" (click)="submitReport()" label="Submit Report" />

</ng-template>
